import * as Sentry from '@sentry/angular-ivy';

// Sentry client key placeholder; the alerting-edge /sentry proxy strips this and injects the
// real Vault-held token server-side. projectId 223 is the alerting-ui Sentry project.
const sentryUser = 'dummyUser';
const projectId = 223;

// Single source of truth for the UI Sentry DSN. Events are proxied through the edge at
// {origin}/sentry/{projectId}; the edge swaps in the real key.
export function buildSentryDsn(): string {
    return `${ window.location.protocol }//${ sentryUser }@${ window.location.host }/sentry/${ projectId }`;
}

// Idempotently ensure Sentry is initialized. SentryErrorHandler inits lazily after bootstrap,
// so early callers (e.g. an APP_INITIALIZER failure path) must guarantee init before capturing;
// otherwise captureException silently no-ops. No-op if a client already exists.
export function ensureSentryInitialized(opts: { environment?: string; release?: string } = {}): void {
    if (Sentry.getCurrentHub().getClient()) {
        return;
    }
    Sentry.init({
        dsn: buildSentryDsn(),
        environment: opts.environment,
        release: opts.release
    });
}
